import { render, staticRenderFns } from "./dividendInfo.vue?vue&type=template&id=9fe7c774&scoped=true"
import script from "./dividendInfo.vue?vue&type=script&lang=js"
export * from "./dividendInfo.vue?vue&type=script&lang=js"
import style0 from "./dividendInfo.vue?vue&type=style&index=0&id=9fe7c774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe7c774",
  null
  
)

export default component.exports